import DojoMetrics from "@classdojo/dojo-metrics";
import LogClientBackend from "@classdojo/dojo-metrics/lib/backends/logClient";
import deployGroup from "src/utils/deployGroup";

export const metrics = new DojoMetrics({
  app: "toolkit",
  env: deployGroup,
  backends: [LogClientBackend()],
});
